export enum ClientSegmentFormField {
  Name = 'name',
  DisplayName = 'displayName',
}

export interface ClientSegmentFormValues {
  [ClientSegmentFormField.Name]: string;
  [ClientSegmentFormField.DisplayName]: string;
}

export const DEFAULT_CLIENT_SEGMENT_FORM_VALUES: ClientSegmentFormValues = {
  [ClientSegmentFormField.Name]: '',
  [ClientSegmentFormField.DisplayName]: '',
};
